import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Header from "../components/Header";
import MainContent from "./MainContent";
import Footer from "../components/Footer";
import useScrollToHash from "../hooks/useScrollToHash";
import FloatingWhatsappButton from "../components/FloatingWhatsappButton";

export default function WebsitePage() {
  useScrollToHash();
  return (
    <>
      <div className="website-wrapper">
        <div className="website-background" />
        <div className="website-background-shade"></div>
        <div className="website-wrapper-inner">
          {
            <>
              {
                //@ts-ignore
                <Helmet>
                  <title>
                    Asempera - Automatizări inteligente pentru case și clădiri
                  </title>
                  <meta
                    name="description"
                    content={`Automatizări inteligente pentru case și clădiri.`}
                  />
                </Helmet>
              }
              <Header />
              <MainContent />
              <Footer />
              <FloatingWhatsappButton />
            </>
          }
        </div>
      </div>
    </>
  );
}
